<template>
  <div class="jobs-page-holder">
    <div class="jobs">
      <div class="main-content-wrapper promos-wrapper">
        <div class="page-header d-flex flex-row align-items-center mb-4">
          <h1 class="m-0 flex-fill font-weight-bold">Promos &amp; Campaigns</h1>
          <div class="d-flex align-items-center gap-3">
            <div class="search-wrapper">
              <svg class="search-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="#718098"/>
              </svg>
              <input
                type="text"
                class="form-control search-input"
                placeholder="Search campaign"
                v-model="searchQuery"
              />
            </div>
            <b-dropdown
              variant="outline-secondary"
              class="region-dropdown"
              menu-class="region-dropdown-menu"
            >
              <template #button-content>
                <div class="region-btn-content">
                  <div class="globe-icon">
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="36" height="36" rx="18" fill="#ECF5FA"/>
                      <path d="M18 30C16.3547 30 14.8021 29.6846 13.3421 29.0539C11.8821 28.4232 10.6088 27.5644 9.52232 26.4777C8.43558 25.3912 7.57684 24.1179 6.94611 22.6579C6.31537 21.1979 6 19.6453 6 18C6 16.3417 6.31537 14.7858 6.94611 13.3323C7.57684 11.8788 8.43558 10.6088 9.52232 9.52232C10.6088 8.43558 11.8821 7.57684 13.3421 6.94611C14.8021 6.31537 16.3547 6 18 6C19.6583 6 21.2142 6.31537 22.6677 6.94611C24.1212 7.57684 25.3912 8.43558 26.4777 9.52232C27.5644 10.6088 28.4232 11.8788 29.0539 13.3323C29.6846 14.7858 30 16.3417 30 18C30 19.6453 29.6846 21.1979 29.0539 22.6579C28.4232 24.1179 27.5644 25.3912 26.4777 26.4777C25.3912 27.5644 24.1212 28.4232 22.6677 29.0539C21.2142 29.6846 19.6583 30 18 30ZM18 28.0784C18.6446 27.2235 19.1872 26.3612 19.6276 25.4915C20.068 24.6218 20.4267 23.6712 20.7038 22.6396H15.2962C15.5895 23.7036 15.9523 24.6704 16.3847 25.5401C16.8169 26.4098 17.3554 27.2559 18 28.0784ZM15.5539 27.7311C15.0697 27.0363 14.6348 26.2465 14.2494 25.3617C13.8639 24.4766 13.5643 23.5693 13.3506 22.6396H9.06568C9.73284 23.9514 10.6276 25.0535 11.7499 25.9459C12.8722 26.8381 14.1402 27.4332 15.5539 27.7311ZM20.4461 27.7311C21.8598 27.4332 23.1278 26.8381 24.2501 25.9459C25.3724 25.0535 26.2672 23.9514 26.9343 22.6396H22.6494C22.3951 23.5773 22.0752 24.4886 21.6897 25.3737C21.3044 26.2587 20.8899 27.0445 20.4461 27.7311ZM8.27116 20.7448H12.9669C12.8876 20.2754 12.83 19.8151 12.7942 19.3639C12.7586 18.9129 12.7408 18.4583 12.7408 18C12.7408 17.5417 12.7586 17.0871 12.7942 16.6361C12.83 16.1849 12.8876 15.7246 12.9669 15.2552H8.27116C8.14968 15.6842 8.05663 16.1303 7.992 16.5935C7.92716 17.0566 7.89474 17.5255 7.89474 18C7.89474 18.4745 7.92716 18.9434 7.992 19.4065C8.05663 19.8697 8.14968 20.3158 8.27116 20.7448ZM14.8614 20.7448H21.1386C21.2178 20.2754 21.2753 19.8192 21.3111 19.3762C21.3466 18.9333 21.3644 18.4745 21.3644 18C21.3644 17.5255 21.3466 17.0667 21.3111 16.6238C21.2753 16.1808 21.2178 15.7246 21.1386 15.2552H14.8614C14.7822 15.7246 14.7247 16.1808 14.6889 16.6238C14.6534 17.0667 14.6356 17.5255 14.6356 18C14.6356 18.4745 14.6534 18.9333 14.6889 19.3762C14.7247 19.8192 14.7822 20.2754 14.8614 20.7448ZM23.0331 20.7448H27.7288C27.8503 20.3158 27.9434 19.8697 28.008 19.4065C28.0728 18.9434 28.1053 18.4745 28.1053 18C28.1053 17.5255 28.0728 17.0566 28.008 16.5935C27.9434 16.1303 27.8503 15.6842 27.7288 15.2552H23.0331C23.1124 15.7246 23.17 16.1849 23.2058 16.6361C23.2414 17.0871 23.2592 17.5417 23.2592 18C23.2592 18.4583 23.2414 18.9129 23.2058 19.3639C23.17 19.8151 23.1124 20.2754 23.0331 20.7448ZM22.6494 13.3604H26.9343C26.2592 12.0324 25.3705 10.9303 24.2684 10.0541C23.1663 9.17811 21.8922 8.57895 20.4461 8.25663C20.9303 8.99179 21.3611 9.79589 21.7383 10.6689C22.1158 11.5418 22.4195 12.4389 22.6494 13.3604ZM15.2962 13.3604H20.7038C20.4105 12.3044 20.0417 11.3315 19.5973 10.4416C19.1526 9.55168 18.6202 8.71168 18 7.92158C17.3798 8.71168 16.8474 9.55168 16.4027 10.4416C15.9583 11.3315 15.5895 12.3044 15.2962 13.3604ZM9.06568 13.3604H13.3506C13.5805 12.4389 13.8842 11.5418 14.2617 10.6689C14.6389 9.79589 15.0697 8.99179 15.5539 8.25663C14.0996 8.57895 12.8235 9.18021 11.7256 10.0604C10.6275 10.9404 9.74084 12.0404 9.06568 13.3604Z" fill="#2A68F5"/>
                    </svg>
                  </div>
                  <span class="region-text">Region: {{ selectedRegion }}</span>
                  <svg class="dropdown-arrow" width="12" height="8" viewBox="0 0 12 8" fill="none">
                    <path d="M1.41 0L6 4.58 10.59 0 12 1.41l-6 6-6-6L1.41 0z" fill="#718098"/>
                  </svg>
                </div>
              </template>
              <b-dropdown-item @click="selectRegion('Australia')" class="region-item">
                <div class="flag-icon-wrapper">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_au)"><path d="M8.92313 4.21941H14.5224V8.46535H8.92313L14.5224 11.2722V12.6774H11.6599L3.95492 8.83762V12.6774H0.0191345C0.104513 14.2356 0.494732 15.7619 1.16769 17.1699L1.82698 17.4282L2.51585 15.2415L3.23125 17.4187L5.34962 16.605L4.12191 18.522L6.05719 19.6962L3.81314 19.9098L3.92926 20.8813C6.13579 22.8925 9.01488 24.0055 12.0004 24.0013C18.6278 24.0013 24.0004 18.6285 24.0004 12.0011C24.0004 6.23866 19.939 1.42518 14.5228 0.266602V1.41387L8.92313 4.21941ZM19.5889 10.131L20.6017 10.5007L20.9323 9.52825L21.2754 10.5107L22.2835 10.141L21.6999 11.0243L22.6379 11.5984L21.5485 11.6984L21.6698 12.7422L20.9201 11.9837L20.2025 12.7665L20.3225 11.7032L19.2544 11.6036L20.1725 11.0195L19.5889 10.131Z" fill="#273376"/><path d="M3.95491 3.84755V3.09648C3.67339 3.35075 3.40463 3.61792 3.14862 3.898V5.12181H14.5224V4.21983H8.92313L14.5224 1.41298V0.265708C14.3989 0.239324 14.2748 0.214825 14.1501 0.19221L6.03283 4.21983H4.17323L12.6436 0.0169464C12.5719 0.0134672 12.4997 0.009987 12.4262 0.0078125H11.6599L3.95491 3.84755Z" fill="#F3F4F5"/><path d="M3.14818 12.6777H3.9549V8.83797L11.6599 12.6777H14.5224L6.01282 8.46569H7.87242L14.5224 11.7653V11.2725L8.92269 8.46569H14.5224V7.60938H3.14818V12.6777Z" fill="#F3F4F5"/><path d="M0.594938 8.25879C0.199799 9.46613 -0.00101593 10.7286 3.8646e-06 11.9989C3.8646e-06 12.2262 0.0063824 12.4521 0.0191393 12.6765H0.594938V8.25879Z" fill="#F3F4F5"/><path d="M3.14863 12.6782V7.60987H14.5224V5.12224H3.14863V3.89844C1.99701 5.15406 1.12641 6.64085 0.59494 8.25962V12.6782H3.14863Z" fill="#CE202C"/><path d="M11.6599 0.0078125H11.5729C8.74854 0.104088 6.04964 1.19809 3.95535 3.09561V3.84668L11.6599 0.0078125Z" fill="#273376"/><path d="M6.03282 4.22013L14.1501 0.192515C13.6521 0.103024 13.1489 0.0449229 12.6436 0.0185547L4.17322 4.22013H6.03282Z" fill="#CE202C"/><path d="M6.01282 8.46582L14.5224 12.6778V11.7654L7.87242 8.46582H6.01282Z" fill="#CE202C"/><path d="M20.3221 11.7033L20.2025 12.7662L20.9201 11.9829L21.6699 12.7414L21.5485 11.6985L22.6379 11.5984L21.6994 11.0244L22.2835 10.1411L21.2754 10.5108L20.9318 9.52832L20.6018 10.5008L19.5889 10.1311L20.1725 11.0196L19.2545 11.6032L20.3221 11.7033Z" fill="#F3F4F5"/><path d="M6.05676 19.6956L4.12149 18.5213L5.34919 16.6043L3.23083 17.418L2.51586 15.2422L1.82786 17.4289L1.16769 17.1705C1.83971 18.5739 2.77739 19.8337 3.92883 20.8802L3.81271 19.9087L6.05676 19.6956Z" fill="#F3F4F5"/></g><defs><clipPath id="clip0_au"><rect width="24" height="24.0004" rx="12" fill="white"/></clipPath></defs></svg>
                </div>
                <span>Australia</span>
              </b-dropdown-item>
              <b-dropdown-item @click="selectRegion('New Zealand')" class="region-item">
                <div class="flag-icon-wrapper">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_nz)"><mask id="mask0_nz" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><path d="M24 12.0002C24 18.6278 18.6274 24.0004 12 24.0004C5.37258 24.0004 0 18.6278 0 12.0002C0 5.37268 5.37258 0 12 0C18.6274 0 24 5.37268 24 12.0002Z" fill="#C4C4C4"/></mask><g mask="url(#mask0_nz)"><path fill-rule="evenodd" clip-rule="evenodd" d="M-6 0H12.0014H30.0028V24.0023H12.0014H-6V0Z" fill="#0437A0"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.51332 -0.000301523H2.0778V4.76216H-5.99436V4.0095H-2.1935L-5.99436 1.47679V0.549148L-0.802964 4.0095H0.867888L-5.15328 -0.0078125H-3.76086L1.52457 3.51651V-0.000301523H1.51332ZM3.92928 -0.000301523H4.49376V3.52402L9.78112 -0.000301523H11.1716L5.15045 4.01701H6.80816L11.9996 0.556682V1.48621L8.20054 4.0189H11.9996V4.77156H3.9274V-0.000301523H3.92928ZM12.0014 7.23654V7.9892H8.20242L12.0014 10.5181V11.4458L6.81004 7.98355H5.13914L11.1603 12.0027H9.76982L4.48246 8.47842V12.0027H3.91798V7.2384L12.0014 7.23654ZM2.07215 12.0009H1.50766V8.47654L-3.77781 12.0009H-5.17018L0.850983 7.98166H-0.819915L-6.01126 11.4439V10.5181L-2.21041 7.98355H-6.01126V7.23089H2.06085V11.9952L2.07215 12.0009Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3.92928 -0.000301522V4.76216H12.0014V7.23654H3.92928V12.0009H2.07215V7.23654H-6.00001V4.76216H2.07215V-0.000301522H3.92928ZM12.0014 11.4439L6.81004 7.98166H5.13914L11.1603 12.0009H11.9958V11.4364L12.0014 11.4439ZM6.80816 4.01701L11.9995 0.556682V-0.0078125H11.1641L5.14291 4.0095L6.80816 4.01701ZM0.860353 4.01701L-5.16082 -0.000301522H-5.99624V0.564193L-0.804849 4.02455L0.860353 4.01701ZM-0.8105 7.98166L-6.00189 11.4439V12.0084H-5.16642L0.854748 7.9892L-0.8105 7.98166Z" fill="#FF1612"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.338 15.8165L21.5713 16.539H22.3239L21.7087 16.9831L21.9439 17.7075L21.3304 17.2578L20.7152 17.7075L20.9522 16.9831L20.3369 16.539H21.0896L21.3229 15.8165H21.338ZM25.2894 7.74418L25.5227 8.46861H26.2753L25.66 8.91456L25.8971 9.6371L25.2818 9.18927L24.6684 9.6371L24.9036 8.91456L24.2883 8.46861H25.041L25.2743 7.74418H25.2894ZM16.9821 8.87317L17.2154 9.5976H17.968L17.3509 10.0435L17.5879 10.7661L16.9689 10.3296L16.3536 10.7774L16.5907 10.0548L15.9735 9.6089H16.7261L16.9613 8.88444L16.9821 8.87317ZM21.4264 4.42871L21.6597 5.15314H22.4124L21.7971 5.60097L22.0342 6.32352L21.4189 5.87569L20.8036 6.32352L21.0407 5.60097L20.4254 5.15314H21.1781L21.4114 4.42871H21.4264Z" fill="#FF1612" stroke="white" stroke-width="0.18667" stroke-miterlimit="2.41"/></g></g><defs><clipPath id="clip0_nz"><rect width="24" height="24.0004" rx="12" fill="white"/></clipPath></defs></svg>
                </div>
                <span>New Zealand</span>
              </b-dropdown-item>
              <b-dropdown-item @click="selectRegion('Canada')" class="region-item">
                <div class="flag-icon-wrapper">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_ca)"><path d="M23.9562 12.0003C23.956 14.755 23.0065 17.4255 21.2674 19.5618C19.5284 21.6982 17.1062 23.1698 14.4089 23.7288C11.7116 24.2879 8.904 23.9001 6.45918 22.6309C4.01436 21.3617 2.08171 19.2886 0.986819 16.7608C-0.108068 14.2331 -0.298269 11.4052 0.448257 8.75359C1.19478 6.10199 2.83241 3.78873 5.08524 2.20354C7.33808 0.618341 10.0684 -0.141911 12.8163 0.0508636C15.5642 0.243638 18.1617 1.37766 20.1711 3.26187C21.3674 4.38106 22.3208 5.73436 22.972 7.23764C23.6231 8.74092 23.9581 10.3621 23.9562 12.0003V12.0003Z" fill="white"/><path d="M3.80717 3.26172V20.7386C2.61229 19.6183 1.65988 18.2647 1.00879 16.7617C0.357702 15.2587 0.0217743 13.6381 0.0217743 12.0002C0.0217743 10.3622 0.357702 8.7416 1.00879 7.23859C1.65988 5.73558 2.61229 4.38207 3.80717 3.26172V3.26172Z" fill="#FF0000"/><path d="M23.9787 12.0002C23.9807 13.6384 23.6457 15.2596 22.9946 16.7628C22.3434 18.2661 21.39 19.6194 20.1937 20.7386V3.26172C21.39 4.38091 22.3434 5.7342 22.9946 7.23749C23.6457 8.74077 23.9807 10.3619 23.9787 12.0002V12.0002Z" fill="#FF0000"/><path d="M14.2393 14.3209L16.4776 12.5033L16.0152 12.324C15.9631 12.3038 15.9203 12.2649 15.8953 12.2149C15.8702 12.1649 15.8647 12.1074 15.8798 12.0535L16.2779 10.637L15.0125 10.8857C14.9511 10.8977 14.8874 10.8855 14.8347 10.8518C14.782 10.8181 14.7443 10.7654 14.7294 10.7047L14.6113 10.2237L13.4783 11.3958C13.4524 11.4231 13.4185 11.4412 13.3814 11.4475C13.3444 11.4538 13.3063 11.4479 13.2729 11.4308C13.2395 11.4136 13.2126 11.3861 13.1961 11.3523C13.1797 11.3185 13.1747 11.2803 13.1818 11.2434L13.638 8.74376L13.0429 9.08454C12.9608 9.12362 12.8672 9.13081 12.7802 9.10474C12.6931 9.07867 12.6189 9.02119 12.5719 8.94345L11.8391 7.50391L11.1063 8.94345C11.0592 9.02111 10.9849 9.07853 10.8979 9.1046C10.8109 9.13066 10.7173 9.12352 10.6353 9.08454L10.0388 8.74419L10.4951 11.2439C10.5022 11.2807 10.4971 11.3189 10.4807 11.3527C10.4643 11.3865 10.4373 11.414 10.4039 11.4312C10.3705 11.4484 10.3324 11.4542 10.2954 11.4479C10.2584 11.4416 10.2244 11.4235 10.1986 11.3962L9.06552 10.2241L8.94874 10.706C8.93374 10.7668 8.89595 10.8195 8.84319 10.8532C8.79042 10.8869 8.72672 10.899 8.66527 10.887L7.40025 10.6383L7.7979 12.0548C7.81323 12.1086 7.80788 12.1662 7.78289 12.2162C7.75791 12.2663 7.71511 12.3052 7.6629 12.3253L7.20013 12.5046L9.43885 14.3222C9.50794 14.3781 9.55618 14.4556 9.5758 14.5422C9.59541 14.6289 9.58525 14.7196 9.54695 14.7998L9.33293 15.2521L11.4679 14.9808C11.5021 14.9765 11.5369 14.9797 11.5698 14.9901C11.6027 15.0006 11.6329 15.0181 11.6584 15.0413C11.6838 15.0646 11.704 15.0932 11.7173 15.125C11.7307 15.1568 11.737 15.1911 11.7358 15.2256L11.6528 17.5052H12.0253L11.942 15.2256C11.9408 15.1911 11.947 15.1568 11.9604 15.125C11.9738 15.0932 11.9939 15.0646 12.0193 15.0413C12.0448 15.0181 12.075 15.0006 12.1079 14.9901C12.1408 14.9797 12.1756 14.9765 12.2098 14.9808L14.3448 15.2521L14.1308 14.7998C14.0923 14.7194 14.0821 14.6284 14.1018 14.5415C14.1215 14.4546 14.17 14.3769 14.2393 14.3209V14.3209Z" fill="#FF0000"/></g><defs><clipPath id="clip0_ca"><rect width="24.0004" height="24.0009" rx="12.0002" fill="white"/></clipPath></defs></svg>
                </div>
                <span>Canada</span>
              </b-dropdown-item>
              <b-dropdown-divider class="region-divider"></b-dropdown-divider>
              <b-dropdown-item @click="selectRegion('All')" class="region-item">
                <div class="globe-icon-item">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M9 0C4.032 0 0 4.032 0 9s4.032 9 9 9 9-4.032 9-9-4.032-9-9-9zm5.814 5.625h-2.385c-.225-1.314-.594-2.556-1.152-3.636 1.665.72 3.042 2.034 3.537 3.636zM9 2.25c.765 1.161 1.341 2.529 1.62 3.9375H7.38C7.659 4.779 8.235 3.411 9 2.25zM2.547 10.6875c-.117-.549-.18-1.116-.18-1.6875s.063-1.1385.18-1.6875h2.745c-.054.5625-.1125 1.125-.1125 1.6875s.0585 1.125.1125 1.6875H2.547zm.639 1.6875h2.385c.225 1.314.594 2.556 1.152 3.636-1.665-.72-3.042-2.034-3.537-3.636zM6.696 5.625H4.311c.495-1.602 1.872-2.916 3.537-3.636-.558 1.08-.927 2.322-1.152 3.636zM9 15.75c-.765-1.161-1.341-2.529-1.62-3.9375h3.24c-.279 1.4085-.855 2.7765-1.62 3.9375zm1.98-5.625H7.02c-.054-.5625-.1125-1.125-.1125-1.6875s.0585-1.125.1125-1.6875h3.96c.054.5625.1125 1.125.1125 1.6875s-.0585 1.125-.1125 1.6875zm.234 6.489c.558-1.08.927-2.322 1.152-3.636h2.385c-.495 1.602-1.872 2.916-3.537 3.636zm1.449-5.931c.054-.5625.1125-1.125.1125-1.6875s-.0585-1.125-.1125-1.6875h2.745c.117.549.18 1.116.18 1.6875s-.063 1.1385-.18 1.6875h-2.745z" fill="#2A68F5"/>
                  </svg>
                </div>
                <span>All</span>
              </b-dropdown-item>
            </b-dropdown>
            <b-dropdown
              variant="outline-secondary"
              class="region-dropdown"
              menu-class="region-dropdown-menu"
            >
              <template #button-content>
                <div class="region-btn-content">
                  <div class="globe-icon">
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="36" height="36" rx="18" fill="#ECF5FA"/>
                      <path d="M18 30C16.3547 30 14.8021 29.6846 13.3421 29.0539C11.8821 28.4232 10.6088 27.5644 9.52232 26.4777C8.43558 25.3912 7.57684 24.1179 6.94611 22.6579C6.31537 21.1979 6 19.6453 6 18C6 16.3417 6.31537 14.7858 6.94611 13.3323C7.57684 11.8788 8.43558 10.6088 9.52232 9.52232C10.6088 8.43558 11.8821 7.57684 13.3421 6.94611C14.8021 6.31537 16.3547 6 18 6C19.6583 6 21.2142 6.31537 22.6677 6.94611C24.1212 7.57684 25.3912 8.43558 26.4777 9.52232C27.5644 10.6088 28.4232 11.8788 29.0539 13.3323C29.6846 14.7858 30 16.3417 30 18C30 19.6453 29.6846 21.1979 29.0539 22.6579C28.4232 24.1179 27.5644 25.3912 26.4777 26.4777C25.3912 27.5644 24.1212 28.4232 22.6677 29.0539C21.2142 29.6846 19.6583 30 18 30ZM18 28.0784C18.6446 27.2235 19.1872 26.3612 19.6276 25.4915C20.068 24.6218 20.4267 23.6712 20.7038 22.6396H15.2962C15.5895 23.7036 15.9523 24.6704 16.3847 25.5401C16.8169 26.4098 17.3554 27.2559 18 28.0784ZM15.5539 27.7311C15.0697 27.0363 14.6348 26.2465 14.2494 25.3617C13.8639 24.4766 13.5643 23.5693 13.3506 22.6396H9.06568C9.73284 23.9514 10.6276 25.0535 11.7499 25.9459C12.8722 26.8381 14.1402 27.4332 15.5539 27.7311ZM20.4461 27.7311C21.8598 27.4332 23.1278 26.8381 24.2501 25.9459C25.3724 25.0535 26.2672 23.9514 26.9343 22.6396H22.6494C22.3951 23.5773 22.0752 24.4886 21.6897 25.3737C21.3044 26.2587 20.8899 27.0445 20.4461 27.7311ZM8.27116 20.7448H12.9669C12.8876 20.2754 12.83 19.8151 12.7942 19.3639C12.7586 18.9129 12.7408 18.4583 12.7408 18C12.7408 17.5417 12.7586 17.0871 12.7942 16.6361C12.83 16.1849 12.8876 15.7246 12.9669 15.2552H8.27116C8.14968 15.6842 8.05663 16.1303 7.992 16.5935C7.92716 17.0566 7.89474 17.5255 7.89474 18C7.89474 18.4745 7.92716 18.9434 7.992 19.4065C8.05663 19.8697 8.14968 20.3158 8.27116 20.7448ZM14.8614 20.7448H21.1386C21.2178 20.2754 21.2753 19.8192 21.3111 19.3762C21.3466 18.9333 21.3644 18.4745 21.3644 18C21.3644 17.5255 21.3466 17.0667 21.3111 16.6238C21.2753 16.1808 21.2178 15.7246 21.1386 15.2552H14.8614C14.7822 15.7246 14.7247 16.1808 14.6889 16.6238C14.6534 17.0667 14.6356 17.5255 14.6356 18C14.6356 18.4745 14.6534 18.9333 14.6889 19.3762C14.7247 19.8192 14.7822 20.2754 14.8614 20.7448ZM23.0331 20.7448H27.7288C27.8503 20.3158 27.9434 19.8697 28.008 19.4065C28.0728 18.9434 28.1053 18.4745 28.1053 18C28.1053 17.5255 28.0728 17.0566 28.008 16.5935C27.9434 16.1303 27.8503 15.6842 27.7288 15.2552H23.0331C23.1124 15.7246 23.17 16.1849 23.2058 16.6361C23.2414 17.0871 23.2592 17.5417 23.2592 18C23.2592 18.4583 23.2414 18.9129 23.2058 19.3639C23.17 19.8151 23.1124 20.2754 23.0331 20.7448ZM22.6494 13.3604H26.9343C26.2592 12.0324 25.3705 10.9303 24.2684 10.0541C23.1663 9.17811 21.8922 8.57895 20.4461 8.25663C20.9303 8.99179 21.3611 9.79589 21.7383 10.6689C22.1158 11.5418 22.4195 12.4389 22.6494 13.3604ZM15.2962 13.3604H20.7038C20.4105 12.3044 20.0417 11.3315 19.5973 10.4416C19.1526 9.55168 18.6202 8.71168 18 7.92158C17.3798 8.71168 16.8474 9.55168 16.4027 10.4416C15.9583 11.3315 15.5895 12.3044 15.2962 13.3604ZM9.06568 13.3604H13.3506C13.5805 12.4389 13.8842 11.5418 14.2617 10.6689C14.6389 9.79589 15.0697 8.99179 15.5539 8.25663C14.0996 8.57895 12.8235 9.18021 11.7256 10.0604C10.6275 10.9404 9.74084 12.0404 9.06568 13.3604Z" fill="#2A68F5"/>
                    </svg>
                  </div>
                  <span class="region-text">End Date: {{ selectedEndDateFilter }}</span>
                  <svg class="dropdown-arrow" width="12" height="8" viewBox="0 0 12 8" fill="none">
                    <path d="M1.41 0L6 4.58 10.59 0 12 1.41l-6 6-6-6L1.41 0z" fill="#718098"/>
                  </svg>
                </div>
              </template>
              <b-dropdown-item @click="selectEndDateFilter('All')" class="region-item">
                <div class="flag-icon-wrapper">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M9 0C4.032 0 0 4.032 0 9s4.032 9 9 9 9-4.032 9-9-4.032-9-9-9zm5.814 5.625h-2.385c-.225-1.314-.594-2.556-1.152-3.636 1.665.72 3.042 2.034 3.537 3.636zM9 2.25c.765 1.161 1.341 2.529 1.62 3.9375H7.38C7.659 4.779 8.235 3.411 9 2.25zM2.547 10.6875c-.117-.549-.18-1.116-.18-1.6875s.063-1.1385.18-1.6875h2.745c-.054.5625-.1125 1.125-.1125 1.6875s.0585 1.125.1125 1.6875H2.547zm.639 1.6875h2.385c.225 1.314.594 2.556 1.152 3.636-1.665-.72-3.042-2.034-3.537-3.636zM6.696 5.625H4.311c.495-1.602 1.872-2.916 3.537-3.636-.558 1.08-.927 2.322-1.152 3.636zM9 15.75c-.765-1.161-1.341-2.529-1.62-3.9375h3.24c-.279 1.4085-.855 2.7765-1.62 3.9375zm1.98-5.625H7.02c-.054-.5625-.1125-1.125-.1125-1.6875s.0585-1.125.1125-1.6875h3.96c.054.5625.1125 1.125.1125 1.6875s-.0585 1.125-.1125 1.6875zm.234 6.489c.558-1.08.927-2.322 1.152-3.636h2.385c-.495 1.602-1.872 2.916-3.537 3.636zm1.449-5.931c.054-.5625.1125-1.125.1125-1.6875s-.0585-1.125-.1125-1.6875h2.745c.117.549.18 1.116.18 1.6875s-.063 1.1385-.18 1.6875h-2.745z" fill="#2A68F5"/>
                  </svg>
                </div>
                <span>All</span>
              </b-dropdown-item>
              <b-dropdown-divider class="region-divider"></b-dropdown-divider>
              <b-dropdown-item @click="selectEndDateFilter('Has End Date')" class="region-item">
                <div class="flag-icon-wrapper">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M14 2H13V1H11V2H5V1H3V2H2C1.45 2 1 2.45 1 3V15C1 15.55 1.45 16 2 16H14C14.55 16 15 15.55 15 15V3C15 2.45 14.55 2 14 2ZM14 15H2V6H14V15Z" fill="#FF6B00"/>
                  </svg>
                </div>
                <span>Has End Date</span>
              </b-dropdown-item>
              <b-dropdown-item @click="selectEndDateFilter('No End Date')" class="region-item">
                <div class="flag-icon-wrapper">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M14 2H13V1H11V2H5V1H3V2H2C1.45 2 1 2.45 1 3V15C1 15.55 1.45 16 2 16H14C14.55 16 15 15.55 15 15V3C15 2.45 14.55 2 14 2ZM14 15H2V6H14V15Z" fill="#718098"/>
                  </svg>
                </div>
                <span>No End Date</span>
              </b-dropdown-item>
              <b-dropdown-item @click="selectEndDateFilter('Ending Soon')" class="region-item">
                <div class="flag-icon-wrapper">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M9 1C4.589 1 1 4.589 1 9s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 14c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z" fill="#15D34A"/>
                    <path d="M9.5 5H8v5l4.25 2.52.75-1.23-3.5-2.08V5z" fill="#15D34A"/>
                  </svg>
                </div>
                <span>Ending Soon (30 days)</span>
              </b-dropdown-item>
            </b-dropdown>
            <b-button variant="dark" class="filter-btn">Filter</b-button>
          </div>
        </div>

        <div
          class="row"
          v-if="isLoading"
          style="display: flex; margin-top: 10px; justify-items: center; align-items: center"
        >
          <b-spinner></b-spinner>
        </div>

        <div class="promos-container" v-if="!isLoading">
          <div
            v-for="promo in filteredPromos"
            :key="promo.id"
            class="promo-card"
          >
            <!-- Left Column -->
            <div class="promo-left">
              <h3 class="promo-title">{{ promo.title }}</h3>
              <div class="promo-code-section">
                <div class="code-wrapper">
                  <div class="code-info">
                    <span class="code-label">Code</span>
                    <strong class="code-value">{{ promo.code }}</strong>
                  </div>
                  <button class="copy-btn" @click="copyCode(promo)">
                    <transition name="fade" mode="out-in">
                      <span v-if="promo.copied" key="copied" class="btn-text">Copied!</span>
                      <svg v-else key="icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" fill="#A9AAAB"/>
                      </svg>
                    </transition>
                  </button>
                </div>
              </div>
            </div>

            <!-- Middle Column -->
            <div class="promo-middle">
              <div class="promo-date-row">
                <div class="date-col">
                  <div class="icon-wrapper icon-calendar">
                    <svg width="21" height="13" viewBox="0 0 21 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.5 12.5V0.5H2.5V12.5H0.5ZM14.5 12.5L13.075 11.1L16.675 7.5H4.5V5.5H16.675L13.1 1.9L14.5 0.5L20.5 6.5L14.5 12.5Z" fill="#A9AAAB"/>
                    </svg>
                  </div>
                  <div class="date-content">
                    <span class="date-label">Start Date</span>
                    <span class="date-value">{{ promo.startDate }}</span>
                  </div>
                </div>
                <div class="date-col">
                  <div class="icon-wrapper icon-flag">
                    <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 17V0H9L9.4 2H15V12H8L7.6 10H2V17H0ZM9.65 10H13V4H7.75L7.35 2H2V8H9.25L9.65 10Z" fill="#FF6B00"/>
                    </svg>
                  </div>
                  <div class="date-content">
                    <span class="date-label">End Date</span>
                    <span class="date-value">{{ promo.endDate }}</span>
                  </div>
                </div>
              </div>

              <div class="promo-region-row">
                <span class="region-flag" v-html="getRegionIcon(promo.regions)"></span>
                <div class="region-info">
                  <span class="region-label">Region</span>
                  <span class="region-name">{{ getRegionText(promo.regions) }}</span>
                </div>
              </div>
            </div>

            <!-- Right Column -->
            <div class="promo-right">
              <div class="promo-tags">
                <span
                  v-for="(condition, index) in promo.conditions"
                  :key="index"
                  class="condition-tag"
                  :class="getConditionClass(condition)"
                >
                  <svg v-if="condition.type === 'success'" class="tag-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10 1.667c-4.583 0-8.333 3.75-8.333 8.333s3.75 8.333 8.333 8.333 8.333-3.75 8.333-8.333-3.75-8.333-8.333-8.333zm-1.667 12.5l-3.333-3.334 1.167-1.166 2.166 2.158 5.5-5.5 1.167 1.175-6.667 6.667z" fill="#15D34A"/>
                  </svg>
                  <svg v-else class="tag-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10 1.667c-4.583 0-8.333 3.75-8.333 8.333s3.75 8.333 8.333 8.333 8.333-3.75 8.333-8.333-3.75-8.333-8.333-8.333zm4.167 11.25l-1.084 1.083L10 11l-3.083 3.083L5.833 12.917 8.917 10 5.833 6.917 6.917 5.833 10 8.917l3.083-3.084 1.084 1.084L11.083 10l3.084 3.083z" fill="#FF6B00"/>
                  </svg>
                  {{ condition.text }}
                </span>
              </div>

              <!-- PDFs & Copies Section -->
              <div v-if="promo.PDF && (Array.isArray(promo.PDF) ? promo.PDF.length > 0 : promo.PDF.trim())" class="pdfs-copies-section">
                <div class="pdfs-header">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M9 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H14C14.5304 16 15.0391 15.7893 15.4142 15.4142C15.7893 15.0391 16 14.5304 16 14V5L9 0Z" fill="#2A68F5"/>
                    <path d="M9 0V5H16" fill="#FFFFFF"/>
                  </svg>
                  <span class="pdfs-title">PDFs & Copies</span>
                </div>
                <div class="pdfs-content" v-html="parsePDFsAndCopies(promo.PDF)"></div>
              </div>

              <div class="promo-notice">
                <div v-if="promo.expanded" class="promo-terms" v-html="sanitizeTerms(promo.termsAndConditions)"></div>
                <a
                  href="#"
                  @click.prevent="toggleExpand(promo)"
                  class="read-more-link"
                >
                  {{ promo.expanded ? 'Read less' : "Read all t&c's" }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { escapeHtml } from '@/support/sanitize';

export default {
  name: 'Promos',
  data() {
    return {
      isLoading: false,
      promos: [],
      searchQuery: '',
      selectedRegion: 'All',
      selectedEndDateFilter: 'All',
    };
  },
  computed: {
    filteredPromos() {
      let filtered = this.promos;

      // Filter by search query
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        filtered = filtered.filter(promo => {
          // Search in title, code, discount rule
          const titleMatch = promo.title.toLowerCase().includes(query);
          const codeMatch = promo.code && promo.code.toLowerCase().includes(query);
          const ruleMatch = promo.discountRule && promo.discountRule.toLowerCase().includes(query);

          // Search in conditions
          const conditionMatch = promo.conditions && promo.conditions.some(condition => {
            return condition.text && condition.text.toLowerCase().includes(query);
          });

          return titleMatch || codeMatch || ruleMatch || conditionMatch;
        });
      }

      // Filter by region
      if (this.selectedRegion !== 'All') {
        filtered = filtered.filter(promo => {
          if (!promo.regions || !Array.isArray(promo.regions)) return false;

          // Check if the selected region exists in the regions array
          return promo.regions.some(region => {
            const regionUpper = region.toUpperCase();
            if (this.selectedRegion === 'Australia') {
              return regionUpper.includes('AUSTRALIA') || regionUpper === 'AU';
            }
            if (this.selectedRegion === 'New Zealand') {
              return regionUpper.includes('NEW ZEALAND') || regionUpper === 'NZ';
            }
            if (this.selectedRegion === 'Canada') {
              return regionUpper.includes('CANADA') || regionUpper === 'CA' || regionUpper === 'CAD';
            }
            return false;
          });
        });
      }

      // Filter by end date
      if (this.selectedEndDateFilter !== 'All') {
        const today = new Date();
        const thirtyDaysFromNow = new Date();
        thirtyDaysFromNow.setDate(today.getDate() + 30);

        filtered = filtered.filter(promo => {
          const hasEndDate = promo.endDate && promo.endDate.trim() !== '' && promo.endDate.toLowerCase() !== 'null';

          if (this.selectedEndDateFilter === 'Has End Date') {
            return hasEndDate;
          } else if (this.selectedEndDateFilter === 'No End Date') {
            return !hasEndDate;
          } else if (this.selectedEndDateFilter === 'Ending Soon') {
            if (!hasEndDate) return false;
            try {
              const endDate = new Date(promo.endDate);
              return endDate >= today && endDate <= thirtyDaysFromNow;
            } catch (e) {
              return false;
            }
          }
          return true;
        });
      }

      return filtered;
    },
  },
  created() {
    this.getPromos();
  },
  methods: {
    selectRegion(region) {
      this.selectedRegion = region;
    },
    selectEndDateFilter(filter) {
      this.selectedEndDateFilter = filter;
    },
    getPromos() {
      this.isLoading = true;
      axios
        .get(`${process.env.VUE_APP_WC_API_URL}/ecommerce-data/promo-pages`)
        .then(response => {
          const getPromo = [];
          response.data.map(promo => {
            // Clean title from HTML
            const cleanTitle = (promo.title || '').replace(/<[^>]*>/g, '').trim();
            const cleanDiscountRule = (promo.discount_rule || '').replace(/<[^>]*>/g, '');

            // Handle regions - check if already an array or needs parsing
            let regions = [];
            if (Array.isArray(promo.regions)) {
              // Already an array, use it directly
              regions = promo.regions;
            } else if (typeof promo.regions === 'string') {
              // It's a string, try to parse it
              try {
                regions = JSON.parse(promo.regions || '[]');
              } catch (e) {
                console.error('Failed to parse regions:', e);
                regions = [];
              }
            } else {
              // Fallback to empty array
              regions = [];
            }

            // Extract conditions from rules
            const conditions = [];
            if (promo.rules) {
              if (promo.rules.success && Array.isArray(promo.rules.success)) {
                promo.rules.success.forEach(rule => {
                  if (rule.text) {
                    conditions.push({ text: rule.text, type: 'success' });
                  }
                });
              }
              if (promo.rules.danger && Array.isArray(promo.rules.danger)) {
                promo.rules.danger.forEach(rule => {
                  if (rule.text) {
                    conditions.push({ text: rule.text, type: 'danger' });
                  }
                });
              }
            }

            // Check if promo is public
            const isPublic = !cleanDiscountRule.toLowerCase().includes('not a public promo');

            // Check if promo is published (only include published promos)
            const isPublished = promo.publish === 1 || promo.publish === true;

            // Only add published promos
            if (isPublished) {
              getPromo.push({
                id: promo.id,
                title: cleanTitle,
                code: promo.discount_code || '',
                discountCode: promo.discount_code,
                brand: promo.brand,
                startDate: promo.start_date,
                startDateTs: new Date(promo.start_date).getTime(),
                endDate: promo.end_date,
                regions: regions,
                regionNote: promo.region_note || regions.join(', '),
                discountRule: cleanDiscountRule,
                termsAndConditions: promo.t_and_c || '',
                combinedWith: promo.combined_with,
                notCombinedWith: promo.not_combined_with,
                PDF: promo.pdfs_and_copies,
                conditions: conditions,
                expanded: false,
                isPublic: isPublic,
                copied: false,
              });
            }
            return getPromo;
          });

          getPromo.sort((a, b) => {
            const keyA = a.startDateTs;
            const keyB = b.startDateTs;
            if (keyA >= keyB) return -1;
            if (keyA < keyB) return 1;
            return 0;
          });

          this.promos = getPromo;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getRegionIcon(regions) {
      if (!regions || !Array.isArray(regions) || regions.length === 0) return '<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="36" height="36" rx="18" fill="#ECF5FA"/><path d="M18 30C16.3547 30 14.8021 29.6846 13.3421 29.0539C11.8821 28.4232 10.6088 27.5644 9.52232 26.4777C8.43558 25.3912 7.57684 24.1179 6.94611 22.6579C6.31537 21.1979 6 19.6453 6 18C6 16.3417 6.31537 14.7858 6.94611 13.3323C7.57684 11.8788 8.43558 10.6088 9.52232 9.52232C10.6088 8.43558 11.8821 7.57684 13.3421 6.94611C14.8021 6.31537 16.3547 6 18 6C19.6583 6 21.2142 6.31537 22.6677 6.94611C24.1212 7.57684 25.3912 8.43558 26.4777 9.52232C27.5644 10.6088 28.4232 11.8788 29.0539 13.3323C29.6846 14.7858 30 16.3417 30 18C30 19.6453 29.6846 21.1979 29.0539 22.6579C28.4232 24.1179 27.5644 25.3912 26.4777 26.4777C25.3912 27.5644 24.1212 28.4232 22.6677 29.0539C21.2142 29.6846 19.6583 30 18 30ZM18 28.0784C18.6446 27.2235 19.1872 26.3612 19.6276 25.4915C20.068 24.6218 20.4267 23.6712 20.7038 22.6396H15.2962C15.5895 23.7036 15.9523 24.6704 16.3847 25.5401C16.8169 26.4098 17.3554 27.2559 18 28.0784ZM15.5539 27.7311C15.0697 27.0363 14.6348 26.2465 14.2494 25.3617C13.8639 24.4766 13.5643 23.5693 13.3506 22.6396H9.06568C9.73284 23.9514 10.6276 25.0535 11.7499 25.9459C12.8722 26.8381 14.1402 27.4332 15.5539 27.7311ZM20.4461 27.7311C21.8598 27.4332 23.1278 26.8381 24.2501 25.9459C25.3724 25.0535 26.2672 23.9514 26.9343 22.6396H22.6494C22.3951 23.5773 22.0752 24.4886 21.6897 25.3737C21.3044 26.2587 20.8899 27.0445 20.4461 27.7311ZM8.27116 20.7448H12.9669C12.8876 20.2754 12.83 19.8151 12.7942 19.3639C12.7586 18.9129 12.7408 18.4583 12.7408 18C12.7408 17.5417 12.7586 17.0871 12.7942 16.6361C12.83 16.1849 12.8876 15.7246 12.9669 15.2552H8.27116C8.14968 15.6842 8.05663 16.1303 7.992 16.5935C7.92716 17.0566 7.89474 17.5255 7.89474 18C7.89474 18.4745 7.92716 18.9434 7.992 19.4065C8.05663 19.8697 8.14968 20.3158 8.27116 20.7448ZM14.8614 20.7448H21.1386C21.2178 20.2754 21.2753 19.8192 21.3111 19.3762C21.3466 18.9333 21.3644 18.4745 21.3644 18C21.3644 17.5255 21.3466 17.0667 21.3111 16.6238C21.2753 16.1808 21.2178 15.7246 21.1386 15.2552H14.8614C14.7822 15.7246 14.7247 16.1808 14.6889 16.6238C14.6534 17.0667 14.6356 17.5255 14.6356 18C14.6356 18.4745 14.6534 18.9333 14.6889 19.3762C14.7247 19.8192 14.7822 20.2754 14.8614 20.7448ZM23.0331 20.7448H27.7288C27.8503 20.3158 27.9434 19.8697 28.008 19.4065C28.0728 18.9434 28.1053 18.4745 28.1053 18C28.1053 17.5255 28.0728 17.0566 28.008 16.5935C27.9434 16.1303 27.8503 15.6842 27.7288 15.2552H23.0331C23.1124 15.7246 23.17 16.1849 23.2058 16.6361C23.2414 17.0871 23.2592 17.5417 23.2592 18C23.2592 18.4583 23.2414 18.9129 23.2058 19.3639C23.17 19.8151 23.1124 20.2754 23.0331 20.7448ZM22.6494 13.3604H26.9343C26.2592 12.0324 25.3705 10.9303 24.2684 10.0541C23.1663 9.17811 21.8922 8.57895 20.4461 8.25663C20.9303 8.99179 21.3611 9.79589 21.7383 10.6689C22.1158 11.5418 22.4195 12.4389 22.6494 13.3604ZM15.2962 13.3604H20.7038C20.4105 12.3044 20.0417 11.3315 19.5973 10.4416C19.1526 9.55168 18.6202 8.71168 18 7.92158C17.3798 8.71168 16.8474 9.55168 16.4027 10.4416C15.9583 11.3315 15.5895 12.3044 15.2962 13.3604ZM9.06568 13.3604H13.3506C13.5805 12.4389 13.8842 11.5418 14.2617 10.6689C14.6389 9.79589 15.0697 8.99179 15.5539 8.25663C14.0996 8.57895 12.8235 9.18021 11.7256 10.0604C10.6275 10.9404 9.74084 12.0404 9.06568 13.3604Z" fill="#2A68F5"/></svg>';

      // Check for specific regions
      const hasAU = regions.some(r => r.toUpperCase().includes('AUSTRALIA') || r.toUpperCase() === 'AU');
      const hasNZ = regions.some(r => r.toUpperCase().includes('NEW ZEALAND') || r.toUpperCase() === 'NZ');
      const hasCA = regions.some(r => r.toUpperCase().includes('CANADA') || r.toUpperCase() === 'CA' || r.toUpperCase() === 'CAD');
      const hasINT = regions.some(r => r.toUpperCase().includes('INTERNATIONAL') || r.toUpperCase() === 'INT');

      // Globe SVG constant
      const globeSvg = '<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="36" height="36" rx="18" fill="#ECF5FA"/><path d="M18 30C16.3547 30 14.8021 29.6846 13.3421 29.0539C11.8821 28.4232 10.6088 27.5644 9.52232 26.4777C8.43558 25.3912 7.57684 24.1179 6.94611 22.6579C6.31537 21.1979 6 19.6453 6 18C6 16.3417 6.31537 14.7858 6.94611 13.3323C7.57684 11.8788 8.43558 10.6088 9.52232 9.52232C10.6088 8.43558 11.8821 7.57684 13.3421 6.94611C14.8021 6.31537 16.3547 6 18 6C19.6583 6 21.2142 6.31537 22.6677 6.94611C24.1212 7.57684 25.3912 8.43558 26.4777 9.52232C27.5644 10.6088 28.4232 11.8788 29.0539 13.3323C29.6846 14.7858 30 16.3417 30 18C30 19.6453 29.6846 21.1979 29.0539 22.6579C28.4232 24.1179 27.5644 25.3912 26.4777 26.4777C25.3912 27.5644 24.1212 28.4232 22.6677 29.0539C21.2142 29.6846 19.6583 30 18 30ZM18 28.0784C18.6446 27.2235 19.1872 26.3612 19.6276 25.4915C20.068 24.6218 20.4267 23.6712 20.7038 22.6396H15.2962C15.5895 23.7036 15.9523 24.6704 16.3847 25.5401C16.8169 26.4098 17.3554 27.2559 18 28.0784ZM15.5539 27.7311C15.0697 27.0363 14.6348 26.2465 14.2494 25.3617C13.8639 24.4766 13.5643 23.5693 13.3506 22.6396H9.06568C9.73284 23.9514 10.6276 25.0535 11.7499 25.9459C12.8722 26.8381 14.1402 27.4332 15.5539 27.7311ZM20.4461 27.7311C21.8598 27.4332 23.1278 26.8381 24.2501 25.9459C25.3724 25.0535 26.2672 23.9514 26.9343 22.6396H22.6494C22.3951 23.5773 22.0752 24.4886 21.6897 25.3737C21.3044 26.2587 20.8899 27.0445 20.4461 27.7311ZM8.27116 20.7448H12.9669C12.8876 20.2754 12.83 19.8151 12.7942 19.3639C12.7586 18.9129 12.7408 18.4583 12.7408 18C12.7408 17.5417 12.7586 17.0871 12.7942 16.6361C12.83 16.1849 12.8876 15.7246 12.9669 15.2552H8.27116C8.14968 15.6842 8.05663 16.1303 7.992 16.5935C7.92716 17.0566 7.89474 17.5255 7.89474 18C7.89474 18.4745 7.92716 18.9434 7.992 19.4065C8.05663 19.8697 8.14968 20.3158 8.27116 20.7448ZM14.8614 20.7448H21.1386C21.2178 20.2754 21.2753 19.8192 21.3111 19.3762C21.3466 18.9333 21.3644 18.4745 21.3644 18C21.3644 17.5255 21.3466 17.0667 21.3111 16.6238C21.2753 16.1808 21.2178 15.7246 21.1386 15.2552H14.8614C14.7822 15.7246 14.7247 16.1808 14.6889 16.6238C14.6534 17.0667 14.6356 17.5255 14.6356 18C14.6356 18.4745 14.6534 18.9333 14.6889 19.3762C14.7247 19.8192 14.7822 20.2754 14.8614 20.7448ZM23.0331 20.7448H27.7288C27.8503 20.3158 27.9434 19.8697 28.008 19.4065C28.0728 18.9434 28.1053 18.4745 28.1053 18C28.1053 17.5255 28.0728 17.0566 28.008 16.5935C27.9434 16.1303 27.8503 15.6842 27.7288 15.2552H23.0331C23.1124 15.7246 23.17 16.1849 23.2058 16.6361C23.2414 17.0871 23.2592 17.5417 23.2592 18C23.2592 18.4583 23.2414 18.9129 23.2058 19.3639C23.17 19.8151 23.1124 20.2754 23.0331 20.7448ZM22.6494 13.3604H26.9343C26.2592 12.0324 25.3705 10.9303 24.2684 10.0541C23.1663 9.17811 21.8922 8.57895 20.4461 8.25663C20.9303 8.99179 21.3611 9.79589 21.7383 10.6689C22.1158 11.5418 22.4195 12.4389 22.6494 13.3604ZM15.2962 13.3604H20.7038C20.4105 12.3044 20.0417 11.3315 19.5973 10.4416C19.1526 9.55168 18.6202 8.71168 18 7.92158C17.3798 8.71168 16.8474 9.55168 16.4027 10.4416C15.9583 11.3315 15.5895 12.3044 15.2962 13.3604ZM9.06568 13.3604H13.3506C13.5805 12.4389 13.8842 11.5418 14.2617 10.6689C14.6389 9.79589 15.0697 8.99179 15.5539 8.25663C14.0996 8.57895 12.8235 9.18021 11.7256 10.0604C10.6275 10.9404 9.74084 12.0404 9.06568 13.3604Z" fill="#2A68F5"/></svg>';

      // If all 4 regions are present, show globe for "All Regions"
      if (hasAU && hasNZ && hasCA && hasINT) {
        return globeSvg;
      }

      // Count how many regions are specified
      const regionCount = [hasAU, hasNZ, hasCA, hasINT].filter(Boolean).length;

      // If multiple regions, show globe
      if (regionCount > 1) {
        return globeSvg;
      }

      // Flag SVG constants
      const auFlag = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_au)"><path d="M8.92313 4.21941H14.5224V8.46535H8.92313L14.5224 11.2722V12.6774H11.6599L3.95492 8.83762V12.6774H0.0191345C0.104513 14.2356 0.494732 15.7619 1.16769 17.1699L1.82698 17.4282L2.51585 15.2415L3.23125 17.4187L5.34962 16.605L4.12191 18.522L6.05719 19.6962L3.81314 19.9098L3.92926 20.8813C6.13579 22.8925 9.01488 24.0055 12.0004 24.0013C18.6278 24.0013 24.0004 18.6285 24.0004 12.0011C24.0004 6.23866 19.939 1.42518 14.5228 0.266602V1.41387L8.92313 4.21941ZM19.5889 10.131L20.6017 10.5007L20.9323 9.52825L21.2754 10.5107L22.2835 10.141L21.6999 11.0243L22.6379 11.5984L21.5485 11.6984L21.6698 12.7422L20.9201 11.9837L20.2025 12.7665L20.3225 11.7032L19.2544 11.6036L20.1725 11.0195L19.5889 10.131Z" fill="#273376"/><path d="M3.95491 3.84755V3.09648C3.67339 3.35075 3.40463 3.61792 3.14862 3.898V5.12181H14.5224V4.21983H8.92313L14.5224 1.41298V0.265708C14.3989 0.239324 14.2748 0.214825 14.1501 0.19221L6.03283 4.21983H4.17323L12.6436 0.0169464C12.5719 0.0134672 12.4997 0.009987 12.4262 0.0078125H11.6599L3.95491 3.84755Z" fill="#F3F4F5"/><path d="M3.14818 12.6777H3.9549V8.83797L11.6599 12.6777H14.5224L6.01282 8.46569H7.87242L14.5224 11.7653V11.2725L8.92269 8.46569H14.5224V7.60938H3.14818V12.6777Z" fill="#F3F4F5"/><path d="M0.594938 8.25879C0.199799 9.46613 -0.00101593 10.7286 3.8646e-06 11.9989C3.8646e-06 12.2262 0.0063824 12.4521 0.0191393 12.6765H0.594938V8.25879Z" fill="#F3F4F5"/><path d="M3.14863 12.6782V7.60987H14.5224V5.12224H3.14863V3.89844C1.99701 5.15406 1.12641 6.64085 0.59494 8.25962V12.6782H3.14863Z" fill="#CE202C"/><path d="M11.6599 0.0078125H11.5729C8.74854 0.104088 6.04964 1.19809 3.95535 3.09561V3.84668L11.6599 0.0078125Z" fill="#273376"/><path d="M6.03282 4.22013L14.1501 0.192515C13.6521 0.103024 13.1489 0.0449229 12.6436 0.0185547L4.17322 4.22013H6.03282Z" fill="#CE202C"/><path d="M6.01282 8.46582L14.5224 12.6778V11.7654L7.87242 8.46582H6.01282Z" fill="#CE202C"/><path d="M20.3221 11.7033L20.2025 12.7662L20.9201 11.9829L21.6699 12.7414L21.5485 11.6985L22.6379 11.5984L21.6994 11.0244L22.2835 10.1411L21.2754 10.5108L20.9318 9.52832L20.6018 10.5008L19.5889 10.1311L20.1725 11.0196L19.2545 11.6032L20.3221 11.7033Z" fill="#F3F4F5"/><path d="M6.05676 19.6956L4.12149 18.5213L5.34919 16.6043L3.23083 17.418L2.51586 15.2422L1.82786 17.4289L1.16769 17.1705C1.83971 18.5739 2.77739 19.8337 3.92883 20.8802L3.81271 19.9087L6.05676 19.6956Z" fill="#F3F4F5"/></g><defs><clipPath id="clip0_au"><rect width="24" height="24.0004" rx="12" fill="white"/></clipPath></defs></svg>';
      const nzFlag = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_nz)"><mask id="mask0_nz" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><path d="M24 12.0002C24 18.6278 18.6274 24.0004 12 24.0004C5.37258 24.0004 0 18.6278 0 12.0002C0 5.37268 5.37258 0 12 0C18.6274 0 24 5.37268 24 12.0002Z" fill="#C4C4C4"/></mask><g mask="url(#mask0_nz)"><path fill-rule="evenodd" clip-rule="evenodd" d="M-6 0H12.0014H30.0028V24.0023H12.0014H-6V0Z" fill="#0437A0"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.51332 -0.000301523H2.0778V4.76216H-5.99436V4.0095H-2.1935L-5.99436 1.47679V0.549148L-0.802964 4.0095H0.867888L-5.15328 -0.0078125H-3.76086L1.52457 3.51651V-0.000301523H1.51332ZM3.92928 -0.000301523H4.49376V3.52402L9.78112 -0.000301523H11.1716L5.15045 4.01701H6.80816L11.9996 0.556682V1.48621L8.20054 4.0189H11.9996V4.77156H3.9274V-0.000301523H3.92928ZM12.0014 7.23654V7.9892H8.20242L12.0014 10.5181V11.4458L6.81004 7.98355H5.13914L11.1603 12.0027H9.76982L4.48246 8.47842V12.0027H3.91798V7.2384L12.0014 7.23654ZM2.07215 12.0009H1.50766V8.47654L-3.77781 12.0009H-5.17018L0.850983 7.98166H-0.819915L-6.01126 11.4439V10.5181L-2.21041 7.98355H-6.01126V7.23089H2.06085V11.9952L2.07215 12.0009Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3.92928 -0.000301522V4.76216H12.0014V7.23654H3.92928V12.0009H2.07215V7.23654H-6.00001V4.76216H2.07215V-0.000301522H3.92928ZM12.0014 11.4439L6.81004 7.98166H5.13914L11.1603 12.0009H11.9958V11.4364L12.0014 11.4439ZM6.80816 4.01701L11.9995 0.556682V-0.0078125H11.1641L5.14291 4.0095L6.80816 4.01701ZM0.860353 4.01701L-5.16082 -0.000301522H-5.99624V0.564193L-0.804849 4.02455L0.860353 4.01701ZM-0.8105 7.98166L-6.00189 11.4439V12.0084H-5.16642L0.854748 7.9892L-0.8105 7.98166Z" fill="#FF1612"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.338 15.8165L21.5713 16.539H22.3239L21.7087 16.9831L21.9439 17.7075L21.3304 17.2578L20.7152 17.7075L20.9522 16.9831L20.3369 16.539H21.0896L21.3229 15.8165H21.338ZM25.2894 7.74418L25.5227 8.46861H26.2753L25.66 8.91456L25.8971 9.6371L25.2818 9.18927L24.6684 9.6371L24.9036 8.91456L24.2883 8.46861H25.041L25.2743 7.74418H25.2894ZM16.9821 8.87317L17.2154 9.5976H17.968L17.3509 10.0435L17.5879 10.7661L16.9689 10.3296L16.3536 10.7774L16.5907 10.0548L15.9735 9.6089H16.7261L16.9613 8.88444L16.9821 8.87317ZM21.4264 4.42871L21.6597 5.15314H22.4124L21.7971 5.60097L22.0342 6.32352L21.4189 5.87569L20.8036 6.32352L21.0407 5.60097L20.4254 5.15314H21.1781L21.4114 4.42871H21.4264Z" fill="#FF1612" stroke="white" stroke-width="0.18667" stroke-miterlimit="2.41"/></g></g><defs><clipPath id="clip0_nz"><rect width="24" height="24.0004" rx="12" fill="white"/></clipPath></defs></svg>';
      const caFlag = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_ca)"><path d="M23.9562 12.0003C23.956 14.755 23.0065 17.4255 21.2674 19.5618C19.5284 21.6982 17.1062 23.1698 14.4089 23.7288C11.7116 24.2879 8.904 23.9001 6.45918 22.6309C4.01436 21.3617 2.08171 19.2886 0.986819 16.7608C-0.108068 14.2331 -0.298269 11.4052 0.448257 8.75359C1.19478 6.10199 2.83241 3.78873 5.08524 2.20354C7.33808 0.618341 10.0684 -0.141911 12.8163 0.0508636C15.5642 0.243638 18.1617 1.37766 20.1711 3.26187C21.3674 4.38106 22.3208 5.73436 22.972 7.23764C23.6231 8.74092 23.9581 10.3621 23.9562 12.0003V12.0003Z" fill="white"/><path d="M3.80717 3.26172V20.7386C2.61229 19.6183 1.65988 18.2647 1.00879 16.7617C0.357702 15.2587 0.0217743 13.6381 0.0217743 12.0002C0.0217743 10.3622 0.357702 8.7416 1.00879 7.23859C1.65988 5.73558 2.61229 4.38207 3.80717 3.26172V3.26172Z" fill="#FF0000"/><path d="M23.9787 12.0002C23.9807 13.6384 23.6457 15.2596 22.9946 16.7628C22.3434 18.2661 21.39 19.6194 20.1937 20.7386V3.26172C21.39 4.38091 22.3434 5.7342 22.9946 7.23749C23.6457 8.74077 23.9807 10.3619 23.9787 12.0002V12.0002Z" fill="#FF0000"/><path d="M14.2393 14.3209L16.4776 12.5033L16.0152 12.324C15.9631 12.3038 15.9203 12.2649 15.8953 12.2149C15.8702 12.1649 15.8647 12.1074 15.8798 12.0535L16.2779 10.637L15.0125 10.8857C14.9511 10.8977 14.8874 10.8855 14.8347 10.8518C14.782 10.8181 14.7443 10.7654 14.7294 10.7047L14.6113 10.2237L13.4783 11.3958C13.4524 11.4231 13.4185 11.4412 13.3814 11.4475C13.3444 11.4538 13.3063 11.4479 13.2729 11.4308C13.2395 11.4136 13.2126 11.3861 13.1961 11.3523C13.1797 11.3185 13.1747 11.2803 13.1818 11.2434L13.638 8.74376L13.0429 9.08454C12.9608 9.12362 12.8672 9.13081 12.7802 9.10474C12.6931 9.07867 12.6189 9.02119 12.5719 8.94345L11.8391 7.50391L11.1063 8.94345C11.0592 9.02111 10.9849 9.07853 10.8979 9.1046C10.8109 9.13066 10.7173 9.12352 10.6353 9.08454L10.0388 8.74419L10.4951 11.2439C10.5022 11.2807 10.4971 11.3189 10.4807 11.3527C10.4643 11.3865 10.4373 11.414 10.4039 11.4312C10.3705 11.4484 10.3324 11.4542 10.2954 11.4479C10.2584 11.4416 10.2244 11.4235 10.1986 11.3962L9.06552 10.2241L8.94874 10.706C8.93374 10.7668 8.89595 10.8195 8.84319 10.8532C8.79042 10.8869 8.72672 10.899 8.66527 10.887L7.40025 10.6383L7.7979 12.0548C7.81323 12.1086 7.80788 12.1662 7.78289 12.2162C7.75791 12.2663 7.71511 12.3052 7.6629 12.3253L7.20013 12.5046L9.43885 14.3222C9.50794 14.3781 9.55618 14.4556 9.5758 14.5422C9.59541 14.6289 9.58525 14.7196 9.54695 14.7998L9.33293 15.2521L11.4679 14.9808C11.5021 14.9765 11.5369 14.9797 11.5698 14.9901C11.6027 15.0006 11.6329 15.0181 11.6584 15.0413C11.6838 15.0646 11.704 15.0932 11.7173 15.125C11.7307 15.1568 11.737 15.1911 11.7358 15.2256L11.6528 17.5052H12.0253L11.942 15.2256C11.9408 15.1911 11.947 15.1568 11.9604 15.125C11.9738 15.0932 11.9939 15.0646 12.0193 15.0413C12.0448 15.0181 12.075 15.0006 12.1079 14.9901C12.1408 14.9797 12.1756 14.9765 12.2098 14.9808L14.3448 15.2521L14.1308 14.7998C14.0923 14.7194 14.0821 14.6284 14.1018 14.5415C14.1215 14.4546 14.17 14.3769 14.2393 14.3209V14.3209Z" fill="#FF0000"/></g><defs><clipPath id="clip0_ca"><rect width="24.0004" height="24.0009" rx="12.0002" fill="white"/></clipPath></defs></svg>';

      // Single region - show specific flag
      if (hasAU) return auFlag;
      if (hasNZ) return nzFlag;
      if (hasCA) return caFlag;
      if (hasINT) return globeSvg;

      // Default to globe
      return globeSvg;
    },
    getRegionText(regions) {
      if (!regions || !Array.isArray(regions) || regions.length === 0) return 'All Regions';

      // Check for specific regions
      const hasAU = regions.some(r => r.toUpperCase().includes('AUSTRALIA') || r.toUpperCase() === 'AU');
      const hasNZ = regions.some(r => r.toUpperCase().includes('NEW ZEALAND') || r.toUpperCase() === 'NZ');
      const hasCA = regions.some(r => r.toUpperCase().includes('CANADA') || r.toUpperCase() === 'CA' || r.toUpperCase() === 'CAD');
      const hasINT = regions.some(r => r.toUpperCase().includes('INTERNATIONAL') || r.toUpperCase() === 'INT');

      // If all 4 regions are present, return "All Regions"
      if (hasAU && hasNZ && hasCA && hasINT) {
        return 'All Regions';
      }

      // Map region names to abbreviations
      const regionAbbreviations = regions.map(region => {
        const upperRegion = region.toUpperCase();
        if (upperRegion.includes('AUSTRALIA') || upperRegion === 'AU') return 'Australia';
        if (upperRegion.includes('NEW ZEALAND') || upperRegion === 'NZ') return 'New Zealand';
        if (upperRegion.includes('CANADA') || upperRegion === 'CA' || upperRegion === 'CAD') return 'Canada';
        if (upperRegion.includes('INTERNATIONAL') || upperRegion === 'INT') return 'International';
        return region;
      });

      // Remove duplicates
      const uniqueRegions = [...new Set(regionAbbreviations)];

      // Join all regions with commas and 'and' for the last one
      if (uniqueRegions.length === 1) {
        return uniqueRegions[0];
      } else if (uniqueRegions.length === 2) {
        return uniqueRegions.join(' & ');
      } else {
        return uniqueRegions.join(', ');
      }
    },
    toggleExpand(promo) {
      promo.expanded = !promo.expanded;
      this.$forceUpdate();
    },
    getConditionClass(condition) {
      // If condition is an object with type property
      if (condition && typeof condition === 'object' && condition.type) {
        return condition.type === 'success' ? 'tag-green' : 'tag-red';
      }
      // Fallback for string conditions
      const lower = typeof condition === 'string' ? condition.toLowerCase() : '';
      if (lower.includes('new orders') || lower.includes('limited') || lower.includes('all glasses')) {
        return 'tag-green';
      }
      if (lower.includes('not applicable')) {
        return 'tag-red';
      }
      if (lower.includes('bto') || lower.includes('contact') || lower.includes('accessories') || lower.includes('optometry')) {
        return 'tag-orange';
      }
      return 'tag-gray';
    },
    copyCode(promo) {
      navigator.clipboard.writeText(promo.code).then(() => {
        promo.copied = true;
        this.$forceUpdate();
        setTimeout(() => {
          promo.copied = false;
          this.$forceUpdate();
        }, 2000);
      }).catch(() => {
        console.error('Failed to copy code');
      });
    },
    sanitizeTerms(html) {
      if (!html) return '';
      return String(html)
        .replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '')
        .replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, '')
        .replace(/\son\w+\s*=\s*["'][^"']*["']/gi, '')
        .replace(/\son\w+\s*=\s*[^\s>]*/gi, '');
    },
    sanitizeUrl(url) {
      const trimmed = String(url).trim().toLowerCase();
      if (trimmed.startsWith('javascript:') || trimmed.startsWith('data:')) return '#';
      return escapeHtml(url);
    },
    parsePDFsAndCopies(data) {
      // Handle new array format
      if (Array.isArray(data)) {
        if (data.length === 0) return '';

        // Separate PDFs from landing pages
        const pdfItems = data.filter(item =>
          item.link && (item.link.toLowerCase().includes('.pdf') || item.text.toLowerCase().includes('pdf'))
        );
        const landingPages = data.filter(item =>
          item.link && !item.link.toLowerCase().includes('.pdf') && !item.text.toLowerCase().includes('pdf')
        );

        let html = '';

        // PDF section
        if (pdfItems.length > 0) {
          html += '<div class="pdf-section">';
          html += '<div class="pdf-label">PDF</div>';
          pdfItems.forEach(item => {
            if (item.text && item.link) {
              const safeLink = this.sanitizeUrl(item.link);
              html += `<a href="${safeLink}" target="_blank" rel="noopener noreferrer" class="pdf-link">${escapeHtml(item.text)}</a>`;
            }
          });
          html += '</div>';
        }

        // Landing pages section
        if (landingPages.length > 0) {
          html += '<div class="landing-pages-section">';
          html += '<div class="landing-pages-label">Landing Page</div>';
          html += '<div class="landing-pages-list">';
          landingPages.forEach(item => {
            if (item.text && item.link) {
              const safeLink = this.sanitizeUrl(item.link);
              html += `<a href="${safeLink}" target="_blank" rel="noopener noreferrer" class="landing-page-link">${escapeHtml(item.text)}</a>`;
            }
          });
          html += '</div></div>';
        }

        return html;
      }

      // Handle old string format for backward compatibility
      if (!data || !data.trim()) return '';

      let html = '';
      let hasPdf = false;
      let hasLandingPages = false;

      // Split by "Landing Pages:" to separate PDF and landing pages
      const parts = data.split(/Landing Pages:/i);

      // Parse PDF Copy
      if (parts[0]) {
        const pdfMatch = parts[0].match(/PDF Copy:\s*(https?:\/\/[^\s]+)/i);
        if (pdfMatch) {
          hasPdf = true;
          const pdfUrl = pdfMatch[1];
          html += '<div class="pdf-section">';
          html += '<div class="pdf-label">PDF</div>';
          html += `<a href="${this.sanitizeUrl(pdfUrl)}" target="_blank" rel="noopener noreferrer" class="pdf-link">PDF Copy</a>`;
          html += '</div>';
        }
      }

      // Parse Landing Pages
      if (parts.length > 1 && parts[1]) {
        const landingPagesText = parts[1].trim();
        const landingPages = landingPagesText.split('|').map(page => page.trim()).filter(page => page);

        if (landingPages.length > 0) {
          hasLandingPages = true;
          html += '<div class="landing-pages-section">';
          html += '<div class="landing-pages-label">Landing Page</div>';
          html += '<div class="landing-pages-list">';

          landingPages.forEach(page => {
            if (page.match(/^https?:\/\//i)) {
              html += `<a href="${this.sanitizeUrl(page)}" target="_blank" rel="noopener noreferrer" class="landing-page-link">${escapeHtml(page)}</a>`;
            } else {
              html += `<span class="landing-page-badge">${escapeHtml(page)}</span>`;
            }
          });

          html += '</div></div>';
        }
      }

      return html;
    },
  },
  watch: {},
};
</script>

<style scoped>
/* Override max-width from global styles */
.promos-wrapper {
  max-width: 100% !important;
  padding: 0 40px !important;
}

/* Header */
.page-header {
  padding-bottom: 20px;
  margin-bottom: 24px;
  border-bottom: none !important;
}

.gap-3 {
  gap: 10px;
}

/* Search Input */
.search-wrapper {
  position: relative;
  width: 300px;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 1;
}

.search-input {
  width: 100%;
  height: 46px;
  padding: 11px 12px 11px 44px;
  border: 1px solid #EAECEE;
  border-radius: 4px;
  background: #FFFFFF;
  font-family: Graphik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.1;
  letter-spacing: -0.01em;
  color: #292A2D;
}

.search-input::placeholder {
  color: #A9AAAB;
}

.search-input:focus {
  outline: none;
  border-color: #2A68F5;
}

/* Region Dropdown */
.region-dropdown >>> .btn {
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid #EAECEE;
  background: #FFFFFF;
  color: #4A4F4A;
  font-family: Graphik, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.1;
  letter-spacing: -0.01em;
  padding: 11px 12px;
  min-width: 200px;
}

.region-dropdown >>> .btn:hover,
.region-dropdown >>> .btn:focus,
.region-dropdown >>> .btn:active {
  background: #FFFFFF;
  border-color: #2A68F5;
  color: #4A4F4A;
}

.region-btn-content {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.globe-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(208, 230, 243, 0.4);
  border-radius: 100px;
}

.region-text {
  flex: 1;
  text-align: left;
}

.dropdown-arrow {
  flex-shrink: 0;
}

/* Region Dropdown Menu */
.region-dropdown >>> .dropdown-menu {
  border: 1px solid #EAECEE;
  border-radius: 4px;
  padding: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 259px;
  background: #FFFFFF;
  margin-top: 4px;
}

.region-dropdown-menu {
  border: 1px solid #EAECEE;
  border-radius: 4px;
  padding: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 259px;
  background: #FFFFFF;
}

.region-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  font-family: Graphik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  color: #292A2D;
  cursor: pointer;
  background: #FFFFFF;
  border: none;
  transition: background-color 0.2s;
}

.region-item:hover {
  background: #F9FAFB;
  color: #292A2D;
}

.region-item:active,
.region-item:focus {
  background: #F9FAFB;
  color: #292A2D;
}

.region-dropdown >>> .dropdown-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  font-family: Graphik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  color: #292A2D;
  background: #FFFFFF;
  border: none;
}

.region-dropdown >>> .dropdown-item:hover {
  background: #F9FAFB;
  color: #292A2D;
}

.region-dropdown >>> .dropdown-divider {
  margin: 0;
  border-top: 1px solid #EAEAEA;
}

.region-divider {
  margin: 0;
  border-top: 1px solid #EAEAEA;
}

.globe-icon-item {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(208, 230, 243, 0.4);
  border-radius: 100px;
  flex-shrink: 0;
}

.globe-icon-item svg {
  width: 18px;
  height: 18px;
}

.flag-icon-wrapper {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;
}

/* Filter Button */
.filter-btn {
  height: 46px;
  padding: 16px 24px;
  border-radius: 4px;
  font-family: Graphik, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.1;
  letter-spacing: -0.01em;
  background: #212721;
  border: none;
  color: #FFFFFF;
}

.filter-btn:hover {
  background: #111827;
}

.filter-btn:active,
.filter-btn:focus {
  background: #212721;
}

/* Promo Cards Container */
.promos-container {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-top: 24px;
}

/* Promo Card - 3 Column Layout */
.promo-card {
  background: #ffffff;
  border-bottom: 1px solid #ECEEF3;
  padding: 24px 0;
  display: grid;
  grid-template-columns: 320px 320px 1fr;
  gap: 53px;
  align-items: start;
}

/* LEFT COLUMN */
.promo-left {
  display: flex;
  flex-direction: column;
  gap: 26px;
  width: 320px;
}

.promo-title {
  font-family: Graphik, sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.1;
  letter-spacing: -0.02em;
  color: #292A2D;
  margin: 0;
}

.promo-code-section {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.code-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 8px 8px 10px;
  background: #FAFAFA;
  border-radius: 4px;
}

.code-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.code-label {
  font-family: Graphik, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.1;
  letter-spacing: -0.01em;
  color: #A9AAAB;
}

.code-value {
  font-family: Graphik, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.1;
  color: #292A2D;
}

.copy-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  transition: all 0.2s ease;
  min-width: 50px;
}

.copy-btn:hover {
  background: rgba(0, 0, 0, 0.05);
}

.copy-btn:active {
  background: rgba(0, 0, 0, 0.1);
}

.copy-btn .btn-text {
  font-family: Graphik, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #2A68F5;
  white-space: nowrap;
}

.fade-enter-active, .fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

.fade-enter-to, .fade-leave {
  opacity: 1;
  transform: scale(1);
}

/* MIDDLE COLUMN */
.promo-middle {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 320px;
}

.promo-date-row {
  display: flex;
  gap: 12px;
}

.date-col {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.icon-wrapper {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.date-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.date-label {
  font-family: Graphik, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.1;
  letter-spacing: -0.01em;
  color: #A9AAAB;
}

.date-value {
  font-family: Graphik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.1;
  letter-spacing: -0.01em;
  color: #292A2D;
}

.promo-region-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.region-flag {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  flex-shrink: 0;
}

.region-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.region-label {
  font-family: Graphik, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.1;
  letter-spacing: -0.01em;
  color: #A9AAAB;
}

.region-name {
  font-family: Graphik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.1;
  letter-spacing: -0.01em;
  color: #292A2D;
}

/* RIGHT COLUMN */
.promo-right {
  display: flex;
  flex-direction: column;
  gap: 14px;
  flex: 1;
}

/* Condition Tags */
.promo-tags {
  display: flex;
  flex-wrap: wrap;
  align-self: stretch;
  gap: 6px;
}

.condition-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 6px;
  border-radius: 4px;
  font-family: Graphik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.214;
  letter-spacing: -0.01em;
}

.tag-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.tag-green {
  background: #EFFCF2;
  color: #292A2D;
}

.tag-orange {
  background: #FFF7F2;
  color: #292A2D;
}

.tag-red {
  background: #FFF7F2;
  color: #292A2D;
}

.tag-gray {
  background: #EFFCF2;
  color: #292A2D;
}

/* PDFs & Copies Section */
.pdfs-copies-section {
  display: flex;
  flex-direction: row;
  padding-bottom: 12px;
  background: #FFFFFF;
  border-bottom: 1px solid #EAEAEA;
}

.pdfs-header {
  display: none;
}

.pdfs-title {
  display: none;
}

.pdfs-content {
  display: flex;
  flex-direction: row;
  width: 100%;
  background-color: #FAFAFA;
  padding: 12px;
}

/* Use deep selector for dynamically generated HTML from v-html */
.pdfs-content >>> .pdf-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-right: 24px;
  border-right: 1px dashed #D0D0D0;
}

.pdfs-content >>> .pdf-label {
  font-family: Graphik, sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  color: #718098;
}

.pdfs-content >>> .pdf-link-item {
  display: flex;
  align-items: center;
}

.pdfs-content >>> .pdf-link {
  font-family: Graphik, sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.4;
  color: #292A2D;
  text-decoration: underline;
  transition: all 0.2s;
}

.pdfs-content >>> .pdf-link:hover {
  color: #2A68F5;
}

.pdfs-content >>> .landing-pages-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-left: 24px;
  flex: 1;
}

.pdfs-content >>> .landing-pages-label {
  font-family: Graphik, sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  color: #718098;
}

.pdfs-content >>> .landing-pages-list {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.pdfs-content >>> .landing-page-badge {
  font-family: Graphik, sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.4;
  color: #292A2D;
  text-decoration: underline;
}

.pdfs-content >>> .landing-page-link {
  font-family: Graphik, sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.4;
  color: #292A2D;
  text-decoration: underline;
  transition: all 0.2s;
}

.pdfs-content >>> .landing-page-link:hover {
  color: #2A68F5;
}

/* Notice Box */
.promo-notice {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 10px;
  padding: 18px;
  background: #FAFAFA;
  border-radius: 4px;
}

.promo-notice strong {
  font-family: Graphik, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.1;
  letter-spacing: -0.01em;
  color: #545557;
}

.promo-terms {
  font-family: Graphik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
  letter-spacing: -0.01em;
  color: #545557;
  margin-top: 4px;
}

.promo-terms >>> ul {
  margin: 8px 0;
  padding-left: 20px;
  list-style-type: disc;
}

.promo-terms >>> li {
  margin: 4px 0;
  color: #545557;
}

.promo-terms >>> div {
  margin: 4px 0;
}

.promo-terms >>> strong {
  font-weight: 600;
  color: #292A2D;
}

.promo-terms >>> br {
  display: block;
  content: "";
  margin: 4px 0;
}

.read-more-link {
  font-family: Graphik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.214;
  letter-spacing: -0.01em;
  color: #545557;
  text-decoration: none;
  align-self: flex-start;
  margin-top: 4px;
  text-decoration: underline;
}

.read-more-link:hover {
  text-decoration: underline;
  color: #545557;
}

@media only screen and (max-width: 1200px) {
  .promo-card {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .page-header {
    flex-direction: column;
    gap: 16px;
  }

  .page-header .d-flex {
    width: 100%;
    flex-direction: column;
  }

  .search-wrapper {
    width: 100%;
  }
}
</style>
